<template>
  <app-layout>
    <FormNav :spamcount="spamCount" />
    <base-card class="space-y-4 mb-10 relative">

      <base-listing v-bind="$props" />

    </base-card>
  </app-layout>
</template>
<script>
import BaseListing from '../components/Listing/BaseListing';
import FormNav from './Partials/FormNav';
export default {
  name: 'FormSubmissions',
  components: {
    BaseListing,
    FormNav,
  },
  props: {
    form: {
      type: Object,
      default: () => {
        return {
          id: 0,
          name: '',
        };
      },
    },
    slug: {
      type: String,
      default: '',
    },
    items: {
      type: Array,
      default: () => {
        return [];
      },
    },
    columns: {
      type: Array,
      default: () => {
        return [];
      },
    },
    routeParams: {
      type: Object,
      default: () => {},
    },
    asyncItems: {
      type: Boolean,
      default: false
    },
    columnSortable: {
      type: Boolean,
      default: false
    },
    horizontalScroll: {
      type: Boolean,
      default: true,
    },
    spamCount: {
      type: Number,
      default: 0
    },
    readUnread: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      showSpam: false,
    };
  },
  mounted() {},
  methods: {},
};
</script>
